import { ProfilesDTO } from "./profiles.dto";
import { Profiles } from "../profiles.entity";
import { Injectable } from "@nestjs/common";

@Injectable()
export class ProfileAdapter{

    public convertDtoToEntity(dto: ProfilesDTO, isUpdate: boolean = false): Profiles{
        const entity = new Profiles();
        entity.profileId = dto.profileId;
        entity.candidateName = dto.candidateName;
        entity.jobDescription = dto.jobDescription;
        entity.profileDate = dto.profileDate;
        entity.mobileNumber = dto.mobileNumber;
        entity.qualification = dto.qualification;
        entity.skills = dto.skills;
        // entity.stack = dto.stack;
        entity.altMobileNumber = dto.altMobileNumber;
        entity.expectedCTC = dto.expectedCTC;
        entity.candidateType = dto.candidateType;
        entity.currentCTC = dto.currentCTC;
        entity.noticePeriod = dto.noticePeriod;
        entity.experience = dto.experience;
        entity.sourceType = dto.sourceType;
        entity.referredBy = dto.referredBy;
        entity.remarks = dto.remarks;
        entity.isActive = dto.isActive == undefined? true: dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
            entity.profileId = dto.profileId;
        }else{
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Profiles): ProfilesDTO{
        const Dto = new ProfilesDTO;
        Dto.profileId = entity.profileId;
        Dto.candidateName = entity.candidateName;
        Dto.jobDescription = entity.jobDescription;
        Dto.profileDate = entity.profileDate;
        Dto.mobileNumber = entity.mobileNumber;
        Dto.qualification = entity.qualification;
        Dto.skills = entity.skills;
        // Dto.stack = entity.stack;
        Dto.altMobileNumber = entity.altMobileNumber;
        Dto.expectedCTC = entity.expectedCTC;
        Dto.candidateType = entity.candidateType;
        Dto.currentCTC = entity.currentCTC;
        Dto.noticePeriod = entity.noticePeriod;
        Dto.experience = entity.experience;
        Dto.sourceType = entity.sourceType;
        Dto.referredBy = entity.referredBy;
        Dto.remarks = entity.remarks;
        Dto.isActive = entity.isActive;
        Dto.createdAt = entity.createdAt;
        Dto.createdUser = entity.createdUser;
        Dto.updatedUser = entity.updatedUser;
        Dto.updatedAt = entity.updatedAt;
        Dto.versionFlag = entity.versionFlag;
        return Dto;
    }
}